import React, { useRef } from "react";
import Button from "components/Form/fields/Button";
import { Field, connect } from "formik";
import { disableSubmit, fieldProps, validEnterKeyPress } from "utils/form";
import { Formik } from "formik";
import { refocusRef } from "utils/view";
import startCase from "lodash/startCase";
import { prepareNewFeature } from "utils/feature";

const COPY_DEFAULTS = {
  title: "New feature",
  body: ""
};

const FEATURE_TEMPLATE = {
  title: "",
  description: "",
  tooltip: "",
  feature_group_uuids: []
};

const DEFAULT_CLASSES = {
  title: "f4 fw5"
};

const FeatureForm = ({ addFeatures, copy, placeholder, customClasses }) => {
  const classes = { ...DEFAULT_CLASSES, ...customClasses };
  const name = "title";
  const inputRef = useRef(null);
  const compCopy = { ...COPY_DEFAULTS, ...copy };

  return (
    <Formik
      validate={(values) => {
        const errors = {};
        if (!values[name]) {
          errors[name] = `${startCase(name)} is required`;
        }
        return errors;
      }}
      initialValues={FEATURE_TEMPLATE}
      onSubmit={(values, actions) => {
        if (addFeatures) {
          addFeatures([prepareNewFeature(values)]);
          // Reset back to template initial values
          actions.resetForm();
        }

        actions.setSubmitting(false);
        refocusRef(inputRef);
      }}
    >
      {({
        values,
        errors,
        touched,
        isSubmitting,
        setFieldValue,
        setFieldTouched,
        submitForm
      }) => {
        const submitDisabled =
          !values[name] ||
          disableSubmit({
            isSubmitting,
            touched,
            errors
          });

        return (
          <div className="flex flex-column">
            {(compCopy.title || compCopy.body) && (
              <div className="dib w-100 flex flex-column pb2">
                {compCopy.title && (
                  <div className="dib w-100 flex flex-row justify-between items-center">
                    <div className={classes.title}>{compCopy.title}</div>
                  </div>
                )}
                {compCopy.body && (
                  <div className="f6 f5-ns pv2 lh-copy">{compCopy.body}</div>
                )}
              </div>
            )}
            <div className="dib w-100 flex flex-row">
              <Field
                disabled={isSubmitting}
                className="f5 border-box input-reset ba pa2 db w-100 br2 lh-copy b--black-20 br--left"
                innerRef={inputRef}
                {...fieldProps({
                  name,
                  placeholder,
                  setFieldValue,
                  setFieldTouched,
                  onKeyPress: ({ key, currentTarget }) => {
                    !submitDisabled &&
                      validEnterKeyPress({ key, currentTarget }) &&
                      submitForm();
                  }
                })}
              />
              <Button
                type="button"
                disabled={submitDisabled}
                loading={isSubmitting}
                copy={"Add"}
                onClick={submitForm}
                styles={{ height: 42 }}
                classes={{
                  button:
                    "fw6 br2 ph3 pv2 border-box input-reset bg-transparent pointer f6 dib flex-shrink-0 br--right"
                }}
              />
            </div>
            {values[name] && touched[name] && errors[name] && (
              <div className="f6 pt2">{errors[name]}</div>
            )}
          </div>
        );
      }}
    </Formik>
  );
};

export default connect(FeatureForm);
